











































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';
import { DuplicateNameDifference } from '@/models/student/check-student-differences-result';

@Component({
  name: 'GDuplicateNameDifferencesTable',
  components: {},
  computed: {},
  methods: {},
})
export default class GDuplicateNameDifferencesTable extends Mixins(GPageBase) {
  currentPageNumber: number = 1;
  itemCountPerPage: number = 10;
  offset = 0;
  // 同姓同名チェック結果のデータ（画面のpaging上に表示させる部分データ）
  displayData: DuplicateNameDifference[] = [];
  // 同姓同名チェック結果の全データ
  @Prop() data: DuplicateNameDifference[];

  mounted() {
    this.setDisplayData();
  }

  handlePageChange(pageNumber: number) {
    this.offset = (pageNumber - 1) * this.itemCountPerPage;
    this.currentPageNumber = pageNumber;
    this.setDisplayData();
  }

  setDisplayData() {
    const maxPageNumber = Math.floor(this.data.length / this.itemCountPerPage) + 1;
    if (this.currentPageNumber === maxPageNumber) {
      this.displayData = this.data.slice(this.offset);
    } else {
      this.displayData = this.data.slice(this.offset, this.offset + this.itemCountPerPage);
    }
  }

  isCheckTypeName(checkType: GEnum.DuplicateNameCheckType): boolean {
    return checkType === GEnum.DuplicateNameCheckType.Name;
  }

  isCheckTypeNameKana(checkType: GEnum.DuplicateNameCheckType): boolean {
    return checkType === GEnum.DuplicateNameCheckType.NameKana;
  }

  get tableColumns(): any {
    return [
      {
        title: this.$t('ROW_NO').toString(),
        slot: 'rowNumDiff',
        width: 60,
        className: 'col-num-right',
      },
      {
        title: this.$t('SIGNIN_ID').toString(),
        slot: 'studentNumberDiff',
        width: 100,
      },
      {
        title: this.$t('LAST_NAME').toString(),
        slot: 'lastNameDiff',
        width: 100,
      },
      {
        title: this.$t('FIRST_NAME').toString(),
        slot: 'firstNameDiff',
        width: 100,
      },
      {
        title: this.$t('FURIGANA_SEI').toString(),
        slot: 'lastNameKanaDiff',
        width: 100,
      },
      {
        title: this.$t('FURIGANA_MEI').toString(),
        slot: 'firstNameKanaDiff',
        width: 100,
      },
      {
        title: this.$t('GRADE').toString(),
        slot: 'gradeDiff',
        width: 100,
        className: 'col-num-right',
      },
      {
        title: this.$t('SCHOOL_CLASS').toString(),
        slot: 'schoolClassNameDiff',
        width: 100,
      },
      {
        title: this.$t('REGISTERED_PLACE').toString(),
        slot: 'registrationPlaceDiff',
      },
    ];
  }
}
